export const SIZES = {
  '5MB': 5 * 1024 * 1024,
  '10MB': 10 * 1024 * 1024,
  '15MB': 15 * 1024 * 1024,
  '20MB': 20 * 1024 * 1024,
  '25MB': 25 * 1024 * 1024,
  '50MB': 50 * 1024 * 1024,
};
